import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private _snackBar: MatSnackBar) { }

  openSnackBar(msg: string, action: string, type?: string, duration?: number) {
    this._snackBar.open(msg, null, { duration: duration ? duration : 3000, panelClass: type==='info' ? ['info-snackbar'] : ['blue-snackbar']});
  }
}
